import { render, staticRenderFns } from "./BchOrder.vue?vue&type=template&id=68e476c9&scoped=true"
import script from "./BchOrder.vue?vue&type=script&lang=js"
export * from "./BchOrder.vue?vue&type=script&lang=js"
import style0 from "./BchOrder.vue?vue&type=style&index=0&id=68e476c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e476c9",
  null
  
)

export default component.exports